/**
 * Content — a publishable article/section the portal surfaces and tracks acceptance for.
 * Derived from coreBOS `cbContent` (policies.evolutivo.ai).
 */
export const contentDescriptor = {
    slug: 'content',
    kind: 'document',
    label: { singular: 'Contenuto', plural: 'Contenuti' },
    table: 'ai_portal_content',
    idStrategy: 'sha256',
    fields: [
        { name: 'title', type: 'text', label: 'Titolo', required: true },
        { name: 'content', type: 'text', label: 'Contenuto' },
        { name: 'description', type: 'text', label: 'Descrizione' },
        { name: 'position', type: 'text', label: 'Posizione' },
        { name: 'page', type: 'text', label: 'Pagina' },
        { name: 'allow_upload', type: 'boolean', label: 'Consenti upload' },
        { name: 'cbcontent_no', type: 'text', label: 'Numero' },
    ],
    relations: [
        { name: 'contenttocontact', kind: 'belongsTo', target: 'contact', toEntitySpine: true },
        { name: 'assigned_user', kind: 'belongsTo', target: 'user', toEntitySpine: true },
    ],
    behaviors: {
        ownership: true,
        audit: true,
        numbering: { prefix: 'CNT', seq: 'ai_portal_content_no' },
        tenantScoped: true,
    },
    emits: ['content.created', 'content.updated'],
    ui: { mode: 'generated', icon: 'FileTextOutlined', navGroup: 'Policy e contenuti', navOrder: 41 },
};
